// Provider & config (app-level setup)
export { GrammarCheckerProvider } from './context/GrammarCheckerProvider';
export type { GrammarCheckerConfig } from './config';
export type { GrammarCheckResult, GrammarCheckAlert } from './types';

// Hook for tool integration
export { default as useGrammarHighlighter } from './hooks/useGrammarHighlighter';
export type { ElementType } from './hooks/useGrammarHighlighter';
